@if (!!maintenanceText) {
  <div
    class="flex-row gap-1 center middle banner maintenance-banner">
    <i class="icon fas fa-exclamation-triangle"></i>
    <div class="label">
      {{ maintenanceText }}
    </div>
  </div>
}
